import { AgGridReact } from 'ag-grid-react';
import { useRef, useState } from 'react';
import Header from '../../common/Header/Header';
import {
  Buttons, Page, TableWrapper
} from '../../common/TableWithButtonsRightLayout/TableWithButtonsRightLayout.styles';
import Table from '../../components/Table/Table';
import { readOnlyLabelTableText } from '../../constants/GlobalTexts';
import { useGetStrategies } from '../../services/strategy/strategy.service';
import { useFetchErrorToast } from '../../utils/useFetchErrorToasts/useFetchErrorToast';
import { Strategy } from "../../services/strategy/strategy.types";
import Button from "../../components/Button/Button";
import { Variant } from "../../components/Button/Button.types";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Divider from "@mui/material/Divider";

const Strategies = () => {
  const navigate = useNavigate();
  const muiTheme = createTheme();
  const gridRef = useRef<AgGridReact>(null);

  const { data: getStrategiesResponse, isError: getStrategiesError } = useGetStrategies();
  useFetchErrorToast([
    {
      isError: getStrategiesError,
      label: 'Error fetching strategies',
      id: 'strategiesFetchError'
    }
  ]);
  const strategies: Strategy[] = getStrategiesResponse?.data || [];

  const [selectedStrategy, setSelectedStrategy] = useState<Strategy | undefined>(undefined)

  function viewStrategy() {
    navigate(`/tables/strategies/${selectedStrategy?.strategyNo}`);
  }

  return (
      <>
        <Header
            breadcrumb={{ to: '/tables', label: 'All tables' }}
            title="Strategies"
            titleTestId={'StrategiesPageTitle'}
        />
        <Page>
          <TableWrapper>
            <Table
                rowData={strategies}
                ref={gridRef}
                height={'100%'}
                returnedRecords={strategies.length}
                readOnlyLabel={readOnlyLabelTableText}
                onSelectionChanged={event => setSelectedStrategy(event.api.getSelectedRows()?.[0])}
                columnDefs={[
                  {
                    width: 30,
                    field: '',
                    headerName: '',
                    checkboxSelection: true,
                    floatingFilter: false,
                    sortable: false
                  },
                  { initialWidth: 100, minWidth: 100, field: 'strategyNo', headerName: 'Strategy' },
                  { initialWidth: 80, minWidth: 80, field: 'statusNo', headerName: 'Status' },
                  { initialWidth: 150, minWidth: 150, field: 'description', headerName: 'Description' },
                  { initialWidth: 70, minWidth: 70, field: 'strategyTpCode', headerName: 'Type' },
                  { initialWidth: 100, minWidth: 100, field: 'conceptNo', headerName: 'Concept' },
                  { initialWidth: 100, minWidth: 100, field: 'occasionNo', headerName: 'Occasion' },
                  { initialWidth: 110, minWidth: 110, field: 'mnemonic', headerName: 'Mnemonic' },
                  { initialWidth: 250, minWidth: 160, field: 'susLongDescription', headerName: 'Sus Description' },
                  { initialWidth: 110, minWidth: 110, field: 'synopsis', headerName: 'Synopsis' }
                ]}
            />
          </TableWrapper>
          <Buttons>
            <Button
                label="Open"
                variant={Variant.Primary}
                onClick={viewStrategy}
                disabled={selectedStrategy === undefined}
            />
            <ThemeProvider theme={muiTheme} key={'time-picker-mui-theme'}>
              <Divider orientation="horizontal" variant={'fullWidth'} flexItem/>
            </ThemeProvider>
            <CSVLink
                data={strategies}
                filename={`Strategies_${new Date().toISOString().split('T')[0]}.csv`}
                style={{ textDecoration: 'none', color: 'inherit' }}
                headers={[
                  { key: 'strategyNo', label: 'Strategy' },
                  { key: 'statusNo', label: 'Status' },
                  { key: 'description', label: 'Description' },
                  { key: 'strategyTpCode', label: 'Type' },
                  { key: 'conceptNo', label: 'Concept' },
                  { key: 'occasionNo', label: 'Occasion' },
                  { key: 'mnemonic', label: 'Mnemonic' },
                  { key: 'susLongDescription', label: 'Sus Description' },
                  { key: 'synopsis', label: 'Synopsis' }
                ]}
            >
              <Button variant={Variant.Secondary} label="Export to CSV"/>
            </CSVLink>
          </Buttons>
        </Page>
      </>
  );
};

export default Strategies;